export const STATE_WORKLOGS_KEY = 'WorklogList';

const breakpoints = [576, 576, 768, 992, 1200];
export const MEDIA_QUERIES = breakpoints.map(
  (bp, i) => `@media (${!i ? 'max-width' : 'min-width'}: ${bp}px)`
);

export const MAX_DESKTOP_WIDTH = '500px';

export const initialMemberPrivateState = {
  userSettings: {
    showStartReview: null,
    showStopReview: null,
    isWorklogsSectionHidden: false,
    isWorklogsListHidden: false,
    isUnauthorizedSectionHidden: false,
    isSelfWorklogsDashboardFilter: false,
    showTrackedTimeOnBadges: true,
    showTrackingMemberOnDashboard: true,
    showTrackingOwnMemberOnDashboard: true,
    showTrackingMemberOnCardBack: true,
    showTrackingOwnMemberOnCardBack: true,
    dashboardSize: 'full',
    showTrackingMemberOnBadges: true,
    showTrackingMemberOnDetailBadges: false,
    useEstimates: true,
    useBoardContext: false,
    showEstimatesOnCardBadges: true,
    highlightUnderestimateCards: false,
    highlightUnderestimateCardsColor: 'red',
  },
};

export const trelloCardFields = [
  'closed',
  'desc',
  'idBoard',
  'idLabels',
  'idList',
  'idMembers',
  'idShort',
  'name',
  'shortUrl',
  'url',
  'labels',
];
